import type { FC } from "react";

import { useTranslations } from "@jti/ui/providers/useTranslations";

import { ActionButtons } from "../../ActionButtons";

import styles from "./PhysicalPrizeConfirmation.module.scss";

export type PhysicalPrizeConfirmationProps = {
  rewardTitle: string;
  onComplete?: () => void;
  onExploreMoreRewards?: () => void;
};

export const PhysicalPrizeConfirmation: FC<PhysicalPrizeConfirmationProps> = ({
  rewardTitle,
  onComplete,
  onExploreMoreRewards,
}) => {
  const { __ } = useTranslations();
  return (
    <>
      <div className={styles.prizeNameWrapper}>
        <h4>{rewardTitle}</h4>
        <div className={styles.textSectionWrapper}>
          <h5 className={styles.textSectionLabel}>{__("loyalty.redeemDialog.nextStepsLabel")}</h5>
          <p className={styles.textSectionDescription}>{__("loyalty.redeemDialog.physical.nextStepsDescription")}</p>
        </div>
      </div>
      <ActionButtons
        primaryButtonLabel={__("loyalty.redeemDialog.confirmButtonText")}
        secondaryButtonLabel={__("loyalty.redeemDialog.exploreMoreRewardsButtonText")}
        onPrimaryButtonClick={onComplete}
        onSecondaryButtonClick={onExploreMoreRewards}
      />
    </>
  );
};
